import { ABI } from "./ABI/ABI";
import { tokenABI } from "./ABI/tokenABI";
import { mUSDTABI } from "./ABI/mUSDTABI";
import { userManager } from "./ABI/userManager";
import { ethers } from "ethers";

const myKey = process.env.REACT_APP_PUBLIC_KEY;

const Web3 = require("web3");

const web3 = new Web3(
  // "https://data-seed-prebsc-2-s1.bnbchain.org:8545" //testnet RPC
  "https://1rpc.io/bnb"
);

// const TokenContractAddress = "0x97F93868515Bc8C63f31EC8e488f6099fDC01176"; //testnet
// const contractAddress = "0xe244abC68F0473256CE98AEae0eA26121d0c4031"; //test net
// const userManagerContractAddress = "0x969DC515BB1e599cfdAc44F38E9b8957557beC8e" //testnet
// const mUSDTAddress = "0x3051ee640D0A935BD181b0b81dde9d80998f4c15";

const mUSDTAddress = "0x55d398326f99059fF775485246999027B3197955";
const TokenContractAddress = "0x1D31BfF25e32b105E2e4Ec8aa37648c0d07D78EB";
const contractAddress = "0x59849650D796C662729a2A41569734a476f6748B";
const userManagerContractAddress = "0x4AB42cb5D6461fdC67Bc95C5Ec5Cd6cbe0ea40BA";

let privateKey = myKey.replace(/"/g, "").trim(); // удаляем лишние кавычки

if (!privateKey.startsWith("0x")) {
  privateKey = "0x" + privateKey;
}

const senderAddress = web3.eth.accounts.privateKeyToAccount(privateKey).address;
console.log(senderAddress);

const contractMLM = new web3.eth.Contract(ABI, contractAddress);
const contractUserManager = new web3.eth.Contract(
  userManager,
  userManagerContractAddress
);

export async function getWinningTickets() {
  let winningTicketsArr = [];
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(ABI, contractAddress);
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const account = accounts[0];

    let winningTicketsLength = await contract.methods
      .winningTicketsCount()
      .call();

    for (let i = 0; i < winningTicketsLength; i++) {
      winningTicketsArr[i] = await contract.methods.winningTickets(i).call();
    }
    return winningTicketsArr;
  } catch (error) {
    console.error("Error creating NFT:", error);
  }
}

//return count of tickets and sold tickets
export async function getSoldTicketCount() {
  try {
    var numberOfTickets = await contractMLM.methods.numberOfTickets().call();
    var numberOfSoldTickets = await contractMLM.methods
      .numberOfSoldTickets()
      .call();
    var cycleCount = await contractMLM.methods
      .cycleCount()
      .call({ from: senderAddress });
    var ticketPrice = await contractMLM.methods.ticketPrice().call();
    ticketPrice = ticketPrice / 10 ** 18;
    let ticketsData = [numberOfSoldTickets, numberOfTickets];

    // // Send a POST request with the data
    // fetch("https://cryptolottery777.com/public/jackpot_sold_ticket_count", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({ ticketsData, ticketPrice, cycleCount }),
    // })
    //   .then((response) => response.json())
    //   .then((responseData) => {
    //     // Process the response data
    //   })
    //   .catch((error) => {
    //     // Handle any errors
    //     console.error("Ero:", error);
    //   });
    // // window.location.reload();
    return ticketsData;
  } catch (error) {
    console.error("Error creating NFT:", error);
  }
}

//return current megajeckpot amount
export async function getMegaJackpotAmount() {
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(ABI, contractAddress);
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const account = accounts[0];

    var megaJackpotAmount = await contract.methods
      .monthlyJackpotWinningAmountCircle()
      .call();
    megaJackpotAmount = megaJackpotAmount / 10 ** 18;

    fetch("https://cryptolottery777.com/public/mega_jackpot_amount", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(megaJackpotAmount),
    })
      .then((response) => response.json())
      .then((responseData) => {
        // Process the response data
      })
      .catch((error) => {
        // Handle any errors
        console.error("Erroro:", error);
      });
    // window.location.reload();
    return megaJackpotAmount;
  } catch (error) {
    console.error("Error creating getMegaJackpotAmount:", error);
  }
}

export async function buyTicket(_account, ticketCount) {
  try {
    // Estimate gas for the transaction
    const estimatedGas = await contractMLM.methods
      .buyTickets(ticketCount)
      .estimateGas({ from: _account });

    // Get the current gas price
    const gasPrice = await web3.eth.getGasPrice();

    // Send the transaction with gas and gasPrice
    var buyTicket = await contractMLM.methods.buyTickets(ticketCount).send({
      from: _account,
      gas: estimatedGas, // Set the estimated gas limit
      gasPrice: gasPrice, // Set the current gas price
    });

    return buyTicket;
    // Send a POST request with the data
  } catch (error) {
    console.error("Error creating buyTicket:", error);
  }
}

export async function tokenApprove(amount) {
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(tokenABI, TokenContractAddress);
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const account = accounts[0];

    // Estimate gas for the transaction
    const estimatedGas = await contract.methods
      .approve(contractAddress, web3.utils.toWei(amount, "ether"))
      .estimateGas({ from: account });

    // Get the current gas price
    const gasPrice = await web3.eth.getGasPrice();

    // Send the transaction with gas and gasPrice
    var approve = await contract.methods
      .approve(contractAddress, web3.utils.toWei(amount, "ether"))
      .send({
        from: account,
        gas: estimatedGas, // Set the estimated gas limit
        gasPrice: gasPrice, // Set the current gas price
      });

    return approve;
    // Send a POST request with the data
  } catch (error) {
    console.error("Error creating tokenApprove:", error);
  }
}

export async function rewardWinners() {
  const web3 = new Web3(window.ethereum);
  const contract = new web3.eth.Contract(ABI, contractAddress);

  try {
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });

    const account = accounts[0];

    const nonce = await web3.eth.getTransactionCount(account);
    const gasLimit = 210000; // Set an initial gas limit

    // Estimate gas for the transaction
    const estimatedGas = await contract.methods
      .rewardWinners()
      .estimateGas({ from: account });

    const gasPrice = await web3.eth.getGasPrice();

    const txData = contract.methods.rewardWinners().encodeABI();

    const rawTx = {
      nonce: web3.utils.toHex(nonce),
      gasPrice: web3.utils.toHex(gasPrice),
      gasLimit: web3.utils.toHex(estimatedGas), // Use the estimated gas
      to: contractAddress,
      data: txData,
    };

    const signedTx = await web3.eth.accounts.signTransaction(rawTx, privateKey);

    const receipt = await web3.eth.sendSignedTransaction(
      signedTx.rawTransaction
    );
  } catch (error) {
    console.error("Error executing transaction:", error);
  }
}

export async function mUSDTMint(amount) {
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(mUSDTABI, mUSDTAddress);
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const account = accounts[0];

    // Calculate the amount in Wei
    const amountInWei = web3.utils.toWei((amount * 25).toString(), "ether");

    // Estimate gas for the transaction
    const estimatedGas = await contract.methods
      .mintTokens(amountInWei)
      .estimateGas({ from: account });

    // Get the current gas price
    const gasPrice = await web3.eth.getGasPrice();

    // Send the transaction with gas and gasPrice
    var mintTokens = await contract.methods.mintTokens(amountInWei).send({
      from: account,
      gas: estimatedGas, // Set the estimated gas limit
      gasPrice: gasPrice, // Set the current gas price
    });
    return mintTokens;
    // Send a POST request with the data
  } catch (error) {
    console.error("Error creating mUSDTMint:", error);
  }
}

export async function getUserBallance() {
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(tokenABI, TokenContractAddress);
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const account = accounts[0];

    const senderAddress =
      web3.eth.accounts.privateKeyToAccount(privateKey).address;
    var balanceOf = await contract.methods.balanceOf(account).call();

    return balanceOf;
    // Send a POST request with the data
  } catch (error) {
    console.error("Error creating getUserBallance:", error);
  }
}

export async function getTicketPrice() {
  try {
    var ticketPrice = await contractMLM.methods.ticketPrice().call();

    return ticketPrice / 10 ** 18;
  } catch (error) {
    console.error("Error creating getTicketPrice:", error);
  }
}

export async function getWinningAddress() {
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(ABI, contractAddress);
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const account = accounts[0];

    let winnerArr = [];
    let winningTicketsCount = await contract.methods
      .winningTicketsCount()
      .call();

    for (let i = 0; i < winningTicketsCount; i++) {
      let winnerObj = {};
      winnerObj.value = await contract.methods.winningTickets(i).call();
      winnerObj.key = await contract.methods
        .ticketNumberToAddress(winnerObj.value)
        .call();
      winnerArr.push(winnerObj);
    }

    fetch("https://cryptolottery777.com/public/winning_tickets_data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(winnerArr),
    })
      .then((response) => response.json())
      .then((responseData) => {
        // Process the response data
      })
      .catch((error) => {
        // Handle any errors
        console.error("Error:", error);
      });
  } catch (error) {
    console.error("Error creating getWinningAddress:", error);
  }
}

export async function getUserInfoForTicketsTable() {
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(ABI, contractAddress);
    const accounts = await web3.eth.getAccounts();
    // const accounts = await window.ethereum.request({
    //   method: "eth_requestAccounts",
    // });
    const account = accounts[0];

    const senderAddress =
      web3.eth.accounts.privateKeyToAccount(privateKey).address;
    var cycleCount = await contract.methods
      .cycleCount()
      .call({ from: senderAddress });

    var userInfo = await contract.methods
      .getUserInfo(account)
      .call({ from: senderAddress });
    return [userInfo, cycleCount];
  } catch (error) {
    console.error("Error creating getUserInfoForTicketsTable:", error);
  }
}

export async function getCycleCount() {
  try {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(ABI, contractAddress);

    const senderAddress =
      web3.eth.accounts.privateKeyToAccount(privateKey).address;
    var cycleCount = await contract.methods
      .cycleCount()
      .call({ from: senderAddress });
    return cycleCount;
  } catch (error) {
    console.error("Error creating getCycleCount:", error);
  }
}

export async function getTicketsStatus() {
  try {
    var tecketsStatus = await contractMLM.methods.getTicketsStatus().call();

    return tecketsStatus;
  } catch (error) {
    console.error("Error creating getTicketPrice:", error);
  }
}

export async function buyTickets(ticketsCount, signer) {
  try {
    console.log("📡 Провайдер перед вызовом buyTickets:", signer);

    if (!signer) {
      console.error("❌ Ошибка: `signer` не передан");
      // alert("Ошибка: `signer` отсутствует");
      return;
    }

    // ✅ Подключаем контракт
    const contract = new ethers.Contract(contractAddress, ABI, signer);

    console.log("🚀 Отправляем `buyTickets()`", { ticketsCount });

    let estimatedGas;
    try {
      // ✅ Оцениваем газ
      estimatedGas = await contract.buyTickets.estimateGas(ticketsCount);
    } catch (gasError) {
      console.error("⛽ Ошибка оценки газа:", gasError);
      // alert("Ошибка оценки газа. Проверьте контракт.");
      return;
    }

    // ✅ Отправляем транзакцию
    const tx = await contract.buyTickets(ticketsCount, {
      gasLimit: estimatedGas,
    });
    console.log("🎟️ Транзакция отправлена:", tx.hash);

    // ✅ Ожидаем подтверждение транзакции в блокчейне
    const receipt = await tx.wait();
    console.log("✅ Транзакция подтверждена:", receipt);

    return receipt;
  } catch (error) {
    console.error("❌ Ошибка в `buyTickets()`:", error);
    // alert(`Ошибка: ${error.message || error}`);
  }
}

export async function buyUniqueTicket(ticketId, signer) {
  try {
    console.log("📡 Провайдер перед вызовом buyUniqueTicket:", signer);

    if (!signer) {
      console.error("❌ Ошибка: `signer` не передан");
      // alert("Ошибка: `signer` отсутствует");
      return;
    }

    // ✅ Подключаем контракт
    const contract = new ethers.Contract(contractAddress, ABI, signer);

    console.log("🚀 Отправляем `buyUniqueTicket()`", { ticketId });

    // ✅ Оцениваем газ (оставил как есть)
    const estimatedGas = await contract.buyUniqueTIcket.estimateGas(ticketId);

    // ✅ Отправляем транзакцию
    const tx = await contract.buyUniqueTIcket(ticketId, {
      gasLimit: estimatedGas,
    });
    console.log("🎟️ Транзакция отправлена:", tx.hash);

    // ✅ Ожидаем подтверждение транзакции в блокчейне
    const receipt = await tx.wait();
    console.log("✅ Транзакция подтверждена:", receipt);

    return receipt;
  } catch (error) {
    console.error("❌ Ошибка в `buyUniqueTicket()`:", error);
    // alert(`Ошибка: ${error.message || error}`);
  }
}

export async function getUserInfo(_account) {
  try {
    var userInfo = await contractUserManager.methods
      .getUserInfo(_account)
      .call();
    console.log("DATA", userInfo?.addressId);

    return userInfo;
  } catch (error) {
    console.error("Error creating getTicketPrice:", error);
  }
}

export async function addressToHisReferrer(_acoount) {
  try {
    var referresAddres = await contractUserManager.methods
      .addressToHisReferrer(_acoount)
      .call();
    return referresAddres;
  } catch (error) {
    console.error("Error get referrer:", error);
  }
}

export async function addUserToMlm(account, referrerId) {
  console.log("myKey", privateKey);
  // ✅ Статичный RPC для BSC Testnet
  const BSC_TESTNET_RPC = "https://1rpc.io/bnb";
  const provider = new ethers.JsonRpcProvider(BSC_TESTNET_RPC);
  try {
    console.log("📡 Начало выполнения `addUserToMlm()`");

    if (!privateKey) {
      console.error("❌ Ошибка: `privateKey` не передан!");
      console.log("privateKey", privateKey);

      return;
    }

    if (!ethers.isAddress(account)) {
      console.log("privateKey", privateKey);
      console.error("❌ Ошибка: Некорректный Ethereum-адрес:", account);
      // alert("Ошибка: Некорректный Ethereum-адрес!");
      return;
    }
    console.log("privateKey", privateKey);
    // ✅ Создаем кошелек через `privateKey`
    const wallet = new ethers.Wallet(privateKey, provider);
    console.log("🔑 Кошелек подключен, адрес:", wallet.address);

    // ✅ Подключаем контракт
    const contract = new ethers.Contract(
      userManagerContractAddress,
      userManager,
      wallet
    );

    // ✅ Приведение ID к `BigInt`
    const referrerIdFormatted = ethers.toBigInt(referrerId);

    console.log("🚀 Отправляем `addUserToMlm()`", {
      account,
      referrerIdFormatted,
    });

    // ✅ Оцениваем газ
    const estimatedGas = await contract.addUserToMlm.estimateGas(
      account,
      referrerIdFormatted
    );

    // ✅ Отправляем транзакцию
    const tx = await contract.addUserToMlm(account, referrerIdFormatted, {
      gasLimit: estimatedGas,
    });

    console.log("🔗 Транзакция отправлена, hash:", tx.hash);

    await tx.wait(); // Ждем подтверждения
    console.log("✅ Транзакция подтверждена!");

    return tx.hash;
  } catch (error) {
    console.error("❌ Ошибка в `addUserToMlm()`:", error);
  }
}

export async function approveUSDT(amount, signer) {
  try {
    console.log("📡 Провайдер перед вызовом approve:", signer);

    if (!signer) {
      console.error("❌ Ошибка: `signer` не передан");
      alert("Ошибка: `signer` отсутствует");
      return;
    }

    const contract = new ethers.Contract(mUSDTAddress, mUSDTABI, signer);
    const amountInWei = ethers.parseUnits(amount.toString(), 18); // Конвертация в Wei

    console.log("🚀 Отправляем `approve()`", { contractAddress, amountInWei });

    // ✅ Оцениваем газ
    const estimatedGas = await contract.approve.estimateGas(
      contractAddress,
      amountInWei
    );

    // ✅ Отправляем транзакцию
    const tx = await contract.approve(contractAddress, amountInWei, {
      gasLimit: estimatedGas,
    });

    console.log("🔗 Транзакция отправлена, hash:", tx.hash);

    // ✅ Ожидаем подтверждение транзакции в блокчейне
    await tx.wait();
    console.log("✅ Транзакция подтверждена!");

    return tx.hash;
  } catch (error) {
    console.error("❌ Ошибка в `approveUSDT()`:", error);
  }
}

export async function getMegaJackpotStartTime() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const megaJackpotStartTime = await contract.monthlyJackpotStartTimestamp(); // Вызываем метод

    return megaJackpotStartTime.toString(); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове getMegaJackpotStartTime:", error);
  }
}

export async function megajackpotCircle() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const cycle = await contract.megajackpotCircle(); // Вызываем метод

    return Number(cycle); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове megajackpotCycle:", error);
  }
}

export async function getUserMegaTickets(_address) {
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider);
    let megaTicketsArray = [];
    let index = await megajackpotCircle();

    while (true) {
      try {
        const megaTickets = await contract.getUserMegaTickets(_address, index);

        if (!megaTickets || megaTickets == 0) break; // Если 0 или пусто – выходим

        megaTicketsArray.push(megaTickets.toString()); // Преобразуем в строку
        index++;
      } catch (error) {
        break; // Ошибка = конец данных
      }
    }

    return megaTicketsArray; // Возвращаем массив строк
  } catch (error) {
    console.error("❌ Ошибка при вызове getUserMegaTickets:", error);
    return [];
  }
}

export async function cycleCount() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const cycle = await contract.cycleCount(); // Вызываем метод

    return Number(cycle); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове megajackpotCycle:", error);
  }
}

export async function winningsTicket() {
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");

  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider);
    let index = await contract.winningTicketsCount();

    index = Number(index); // Преобразуем BigInt в Number

    if (index === 0) return []; // Если билетов нет – сразу выход

    const ticketPromises = Array.from({ length: index }, (_, i) =>
      contract.winningTickets(i)
    );

    const results = await Promise.allSettled(ticketPromises);

    const winningTickets = results
      .filter(
        ({ status, value }) => status === "fulfilled" && value && value !== 0n
      ) // Проверка на BigInt 0n
      .map(({ value }) => value.toString());

    console.log("WT", winningTickets);
    return winningTickets;
  } catch (error) {
    console.error("❌ Ошибка при вызове winningsTicket:", error);
    return [];
  }
}

export async function jackpotReward() {
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");

  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider);
    let index = await contract.winningTicketsCount();

    index = Number(index); // Преобразуем BigInt в Number

    if (index === 0) return []; // Если билетов нет – сразу выход

    // Запрашиваем сразу все адреса победителей
    const ticketPromises = Array.from({ length: index }, (_, i) =>
      contract.winningTickets(i)
    );
    const addresses = await Promise.allSettled(ticketPromises);

    // Запрашиваем все вознаграждения по адресам
    const rewardPromises = addresses
      .filter(({ status }) => status === "fulfilled")
      .map(({ value }) => contract.ticketIdToReward(value));

    const rewards = await Promise.allSettled(rewardPromises);

    // Обрабатываем успешные результаты и преобразуем BigInt в обычное число
    const winningTickets = rewards
      .filter(
        ({ status, value }) =>
          status === "fulfilled" && value && Number(value) !== 0
      )
      .map(({ value }) => (Number(value) / 10 ** 18).toString()); // Преобразуем BigInt → Number

    console.log("JR", winningTickets);
    return winningTickets;
  } catch (error) {
    console.error("❌ Ошибка при вызове jackpotReward:", error);
    return [];
  }
}

export async function buyMegaTickets(ticketsCount, signer) {
  try {
    console.log("📡 Провайдер перед вызовом buyTickets:", signer);

    if (!signer) {
      console.error("❌ Ошибка: `signer` не передан");
      // alert("Ошибка: `signer` отсутствует");
      return;
    }

    // ✅ Подключаем контракт
    const contract = new ethers.Contract(contractAddress, ABI, signer);

    console.log("🚀 Отправляем `buyMegaTickets()`", { ticketsCount });

    let estimatedGas;
    try {
      // ✅ Оцениваем газ
      estimatedGas = await contract.buyMegaTickets.estimateGas(ticketsCount);
    } catch (gasError) {
      console.error("⛽ Ошибка оценки газа:", gasError);
      // alert("Ошибка оценки газа. Проверьте контракт.");
      return;
    }

    // ✅ Отправляем транзакцию
    const tx = await contract.buyMegaTickets(ticketsCount, {
      gasLimit: estimatedGas,
    });
    console.log("🎟️ Транзакция отправлена:", tx.hash);

    // ✅ Ожидаем подтверждение транзакции в блокчейне
    const receipt = await tx.wait();
    console.log("✅ Транзакция подтверждена:", receipt);

    return receipt;
  } catch (error) {
    console.error("❌ Ошибка в `buyTickets()`:", error);
    // alert(`Ошибка: ${error.message || error}`);
  }
}

export async function getMegaTicketsCount() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const megaTicketsCount = await contract.megaTicketsCountLimit(); // Вызываем метод

    return Number(megaTicketsCount); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове getMegaTicketaCount:", error);
  }
}

export async function getMegaTicketsPrice() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const megaTicketsPrice = await contract.megaTicketsPrice(); // Вызываем метод

    return Number(megaTicketsPrice) / 10 ** 18; // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове getMegaTicketsPrice:", error);
  }
}

export async function getMegaTicketsSoldCount() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const megaTicketsPrice = await contract.megaTicketsCount(); // Вызываем метод

    return Number(megaTicketsPrice); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове getMegaTicketsSoldCount:", error);
  }
}

export async function startMegaJackpot() {
  // ✅ Статичный RPC для BSC Testnet
  const BSC_TESTNET_RPC = "https://1rpc.io/bnb";
  const provider = new ethers.JsonRpcProvider(BSC_TESTNET_RPC);

  try {
    console.log("📡 Начало выполнения activateMegaJackpot()");

    if (!privateKey) {
      console.error("❌ Ошибка: privateKey не передан!");
      return;
    }

    // ✅ Создаем кошелек через privateKey
    const wallet = new ethers.Wallet(privateKey, provider);
    console.log("🔑 Кошелек подключен, адрес:", wallet.address);

    // ✅ Подключаем контракт
    const contract = new ethers.Contract(contractAddress, ABI, wallet);

    console.log("🚀 Отправляем activateMegaJackpot(true)");

    // ✅ Оцениваем газ
    const estimatedGas = await contract.activateMegaJackpot.estimateGas(true);

    // ✅ Отправляем транзакцию
    const tx = await contract.activateMegaJackpot(true, {
      gasLimit: estimatedGas,
    });

    console.log("🔗 Транзакция отправлена, hash:", tx.hash);

    await tx.wait(); // Ждем подтверждения
    console.log("✅ Транзакция подтверждена!");

    return tx.hash;
  } catch (error) {
    console.error("❌ Ошибка в activateMegaJackpot():", error);
  }
}

export async function userInfo(_account) {
  try {
    var userInfo = await contractUserManager.methods.userInfo(_account).call();
    console.log("DATA", userInfo?.addressId);

    return userInfo;
  } catch (error) {
    console.error("Error creating getTicketPrice:", error);
  }
}

export async function userLvl(_account) {
  try {
    var userInfo = await contractUserManager.methods.userLevel(_account).call();
    console.log("DATA", userInfo);

    return userInfo;
  } catch (error) {
    console.error("Error creating getTicketPrice:", error);
  }
}

export async function ticketsInCurrentLevel(_account) {
  try {
    var userInfo = await contractUserManager.methods
      .ticketsInCurrentLevel(_account)
      .call();
    console.log("DATA", userInfo);

    return userInfo;
  } catch (error) {
    console.error("Error creating ticketsInCurrentLevel:", error);
  }
}

export async function startJackpot() {
  const web3 = new Web3("https://1rpc.io/bnb");

  try {
    console.log("📡 Запуск `rewardWinners()`...");

    if (!privateKey) throw new Error("❌ Приватный ключ не найден!");

    const account = web3.eth.accounts.privateKeyToAccount(privateKey);
    web3.eth.accounts.wallet.add(account);

    const contract = new web3.eth.Contract(ABI, contractAddress);
    const gasPrice = await web3.eth.getGasPrice();

    // 🔍 Сначала симулируем вызов — узнаем причину ошибки, если есть
    try {
      await contract.methods.rewardWinners().call({ from: account.address });
      console.log("✅ Симуляция прошла успешно (call). Продолжаем...");
    } catch (callError) {
      throw new Error(`🛑 Ошибка при симуляции вызова: ${callError.message}`);
    }

    const estimatedGas = await contract.methods
      .rewardWinners()
      .estimateGas({ from: account.address });
    const gasLimit = Math.floor(estimatedGas * 1.2); // 🛡️ 20% запас

    const tx = {
      from: account.address,
      to: contractAddress,
      gas: gasLimit,
      gasPrice,
      data: contract.methods.rewardWinners().encodeABI(),
    };

    const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);
    const sentTx = await web3.eth.sendSignedTransaction(
      signedTx.rawTransaction
    );

    console.log("⏳ Транзакция отправлена. Ожидание подтверждения...");

    const receipt = await waitForReceipt(web3, sentTx.transactionHash);

    console.log("✅ Транзакция подтверждена!");
    console.log("🔍 Хэш транзакции:", receipt.transactionHash);
    console.log("⛽ Газ использован:", receipt.gasUsed);

    return { success: true, receipt };
  } catch (error) {
    console.error("❌ Ошибка:", error.message || error);
    return { success: false, error };
  }
}

// 📦 Функция ожидания подтверждения
async function waitForReceipt(web3, txHash) {
  let receipt = null;
  while (!receipt) {
    receipt = await web3.eth.getTransactionReceipt(txHash);
    if (!receipt) await new Promise((resolve) => setTimeout(resolve, 2000));
  }
  return receipt;
}

export const sendPurchaseToOffer18 = (amount = 5) => {
  const clickId = "D-21490508-1746704904-35G188G50G224-HJRUP4791";

  if (!clickId) {
    console.warn(
      "❗ Click ID не найден — пользователь не пришёл по партнёрской ссылке."
    );
    return;
  }

  const offerId = "21490508";
  const aid = "633486";
  const apiKey = "8a388266783df85e1ed6ed83173a0889"; // ← твой настоящий API-ключ

  const url = `https://api.offer18.com/api/m/offers?click_id=${clickId}&offer_id=${offerId}&amount=${amount}&aid=${aid}&key=${apiKey}`;

  fetch(url)
    .then((res) => res.json())
    .then((data) => {
      console.log("✅ Purchase recorded:", data);
    })
    .catch((err) => {
      console.error("❌ Error sending to Offer18:", err);
    });
};

export async function timeForMega() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const time = await contract.timeForMega(); // Вызываем метод

    return Number(time); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове megajackpotCycle:", error);
  }
}
// export async function megaJackpotAmount() {
//   // Подключаемся к BSC Testnet через публичный RPC
//   const provider = new ethers.JsonRpcProvider(
//     "https://1rpc.io/bnb"
//   );
//   try {
//     const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

//     const montleyAmount = await contract.monthlyJackpotWinningAmountCircle (); // Вызываем метод

//     return Number(montleyAmount) / 10 ** 18; // Возвращаем значение
//   } catch (error) {
//     console.error("❌ Ошибка при вызове megajackpotCycle:", error);
//   }
// }

export async function megaJackpotAmount() {
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");

  const contract = new ethers.Contract(contractAddress, ABI, provider);

  // Вспомогательная проверка нуля для bigint/BigNumber/чисел
  const isZero = (v) =>
    (typeof v === "bigint" && v === 0n) ||
    (typeof v === "number" && v === 0) ||
    v?.isZero?.() === true;

  try {
    // 1) Пытаемся взять основной monthlyJackpotWinningAmount
    let amount = await contract.monthlyJackpotWinningAmount();

    // 2) Если он ноль — берём запасной monthlyJackpotWinningAmountCircle
    if (isZero(amount)) {
      amount = await contract.monthlyJackpotWinningAmountCircle();
    }

    // Возвращаем как Number в единицах USDT/BNB (18 знаков)
    return Number(ethers.formatUnits(amount, 18));
  } catch (err) {
    // Если основной вызов упал — пробуем сразу запасной
    try {
      const fallbackAmount = await contract.monthlyJackpotWinningAmountCircle();
      return Number(ethers.formatUnits(fallbackAmount, 18));
    } catch (fallbackErr) {
      console.error("❌ Ошибка при вызове monthly jackpot:", err, fallbackErr);
      return 0; // или можно вернуть null, как удобнее в вашем UI
    }
  }
}

export async function isMegaActive() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const isActive = await contract.isMegaJackpotActive(); // Вызываем метод
    console.log("isActive", isActive);

    return isActive; // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове megajackpotCycle:", error);
  }
}

export async function monthlyJackpotStartTimestamp() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const montleyTime = await contract.monthlyJackpotStartTimestamp(); // Вызываем метод

    return Number(montleyTime); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове monthlyJackpotStartTimestamp:", error);
  }
}
export async function megaTicketsPrice() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const megaPrice = await contract.megaTicketsPrice(); // Вызываем метод

    return Number(megaPrice) / 10 ** 18; // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове monthlyJackpotStartTimestamp:", error);
  }
}
export async function megaTicketsCount() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const megaTicketsLimit = await contract.megaTicketsCount(); // Вызываем метод

    return Number(megaTicketsLimit); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове monthlyJackpotStartTimestamp:", error);
  }
}
export async function megaTicketsCountLimit() {
  // Подключаемся к BSC Testnet через публичный RPC
  const provider = new ethers.JsonRpcProvider("https://1rpc.io/bnb");
  try {
    const contract = new ethers.Contract(contractAddress, ABI, provider); // Подключаем контракт

    const megaTicketsLimit = await contract.megaTicketsCountLimit(); // Вызываем метод

    return Number(megaTicketsLimit); // Возвращаем значение
  } catch (error) {
    console.error("❌ Ошибка при вызове monthlyJackpotStartTimestamp:", error);
  }
}
export async function calculateMega() {
  const web3 = new Web3("https://1rpc.io/bnb");

  try {
    console.log("📡 Запуск `calculateMegaJackpot()`...");

    if (!privateKey) throw new Error("❌ Приватный ключ не найден!");

    const account = web3.eth.accounts.privateKeyToAccount(privateKey);
    web3.eth.accounts.wallet.add(account);

    const contract = new web3.eth.Contract(ABI, contractAddress);
    const gasPrice = await web3.eth.getGasPrice();

    // 🔍 Сначала симулируем вызов — узнаем причину ошибки, если есть
    try {
      await contract.methods
        .deactivateMegaJackpot(true)
        .call({ from: account.address });
      console.log("✅ Симуляция прошла успешно (call). Продолжаем...");
    } catch (callError) {
      throw new Error(`🛑 Ошибка при симуляции вызова: ${callError.message}`);
    }

    const estimatedGas = await contract.methods
      .deactivateMegaJackpot(true)
      .estimateGas({ from: account.address });
    const gasLimit = Math.floor(estimatedGas * 1.2); // 🛡️ 20% запас

    const tx = {
      from: account.address,
      to: contractAddress,
      gas: gasLimit,
      gasPrice,
      data: contract.methods.deactivateMegaJackpot(true).encodeABI(),
    };

    const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);
    const sentTx = await web3.eth.sendSignedTransaction(
      signedTx.rawTransaction
    );

    console.log("⏳ Транзакция отправлена. Ожидание подтверждения...");

    const receipt = await waitForReceipt(web3, sentTx.transactionHash);

    console.log("✅ Транзакция подтверждена!");
    console.log("🔍 Хэш транзакции:", receipt.transactionHash);
    console.log("⛽ Газ использован:", receipt.gasUsed);

    return { success: true, receipt };
  } catch (error) {
    console.error("❌ Ошибка:", error.message || error);
    return { success: false, error };
  }
}

export async function changeTicketPrice(price) {
  const web3 = new Web3("https://1rpc.io/bnb");

  try {
    console.log("📡 Запуск `rewardWinners()`...");

    if (!privateKey) throw new Error("❌ Приватный ключ не найден!");

    const account = web3.eth.accounts.privateKeyToAccount(privateKey);
    web3.eth.accounts.wallet.add(account);

    const contract = new web3.eth.Contract(ABI, contractAddress);
    const gasPrice = await web3.eth.getGasPrice();

    // 🔍 Сначала симулируем вызов — узнаем причину ошибки, если есть
    try {
      await contract.methods
        .setTicketPrice(price)
        .call({ from: account.address });
      console.log("✅ Симуляция прошла успешно (call). Продолжаем...");
    } catch (callError) {
      throw new Error(`🛑 Ошибка при симуляции вызова: ${callError.message}`);
    }

    const estimatedGas = await contract.methods
      .setTicketPrice(price)
      .estimateGas({ from: account.address });
    const gasLimit = Math.floor(estimatedGas * 1.2); // 🛡️ 20% запас

    const tx = {
      from: account.address,
      to: contractAddress,
      gas: gasLimit,
      gasPrice,
      data: contract.methods.setTicketPrice(price).encodeABI(),
    };

    const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);
    const sentTx = await web3.eth.sendSignedTransaction(
      signedTx.rawTransaction
    );

    console.log("⏳ Транзакция отправлена. Ожидание подтверждения...");

    const receipt = await waitForReceipt(web3, sentTx.transactionHash);

    console.log("✅ Транзакция подтверждена!");
    console.log("🔍 Хэш транзакции:", receipt.transactionHash);
    console.log("⛽ Газ использован:", receipt.gasUsed);

    return { success: true, receipt };
  } catch (error) {
    console.error("❌ Ошибка:", error.message || error);
    return { success: false, error };
  }
}

export async function setAdminFunction(account) {
  // ✅ Статичный RPC для BSC Testnet
  const BSC_TESTNET_RPC = "https://1rpc.io/bnb";
  const provider = new ethers.JsonRpcProvider(BSC_TESTNET_RPC);
  try {
    console.log("📡 Начало выполнения `addUserToMlm()`");

    if (!privateKey) {
      console.error("❌ Ошибка: `privateKey` не передан!");
      return;
    }

    if (!ethers.isAddress(account)) {
      console.error("❌ Ошибка: Некорректный Ethereum-адрес:", account);
      // alert("Ошибка: Некорректный Ethereum-адрес!");
      return;
    }

    // ✅ Создаем кошелек через `privateKey`
    const wallet = new ethers.Wallet(privateKey, provider);
    console.log("🔑 Кошелек подключен, адрес:", wallet.address);

    // ✅ Подключаем контракт
    const contract = new ethers.Contract(
      userManagerContractAddress,
      userManager,
      wallet
    );

    console.log("🚀 Отправляем `addUserToMlm()`", { account });

    // ✅ Оцениваем газ
    const estimatedGas = await contract.setAdminStatus.estimateGas(account);

    // ✅ Отправляем транзакцию
    const tx = await contract.setAdminStatus(account, {
      gasLimit: estimatedGas,
    });

    console.log("🔗 Транзакция отправлена, hash:", tx.hash);

    await tx.wait(); // Ждем подтверждения
    console.log("✅ Транзакция подтверждена!");

    return tx.hash;
  } catch (error) {
    console.error("❌ Ошибка в `addUserToMlm()`:", error);
  }
}

//----------------------------------- Offer18 functionality  --------------------------------------------------//

// Вспомогательная функция для получения параметра из URL
// Вспомогательная функция для получения параметра из URL
function getQueryParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

// export async function sendOffer18Conversion(amount = 25, count = 10) {
//   const affClickId = getQueryParam("aff_click_id"); // берем из URL
//   const subAffId = getQueryParam("sub_aff_id"); // тоже из URL

//   if (!affClickId) {
//     console.error("aff_click_id не найден в URL");
//     return;
//   }

//   const tid = affClickId;
//   console.log("tid", tid, "count", count);

//   let results = [];

//   for (let i = 0; i < count; i++) {
//     let postbackUrl = `https://cryptolottery777.o18a.com/p?m=23804&tid=${encodeURIComponent(
//       tid
//     )}&amount=${amount}`;

//     if (subAffId) {
//       postbackUrl += `&sub_aff_id=${encodeURIComponent(subAffId)}`;
//     }

//     try {
//       const res = await fetch(postbackUrl, { method: "GET" });
//       const text = await res.text();
//       console.log(`✅ [${i + 1}] Offer18 Postback Response:`, text);
//       results.push(text);
//     } catch (err) {
//       console.error(`❌ Ошибка при отправке конверсии #${i + 1}:`, err);
//       results.push(null);
//     }
//   }

//   return results;
// }

// Получаем статистику offer18 по affilate

export async function fetchOffer18Reports() {
  const options = {
    method: "GET",
    headers: {
      Accept:
        "text/html, application/xhtml+xml, application/xml;q=0.9, image/webp",
    },
  };

  const now = new Date();
  const dateEnd = now.toISOString().slice(0, 10);

  const past = new Date(now);
  past.setDate(past.getDate() - 30);
  const dateFrom = past.toISOString().slice(0, 10);

  // Берём исходный URL и заменяем даты
  const baseUrl =
    "https://api.offer18.com/api/af/report/?date_from=2025-08-12&date_end=2025-08-12&results=100&page=0&timezone=0.00&fields=clicks%2Cconversion%2Caffiliate_price%2Cdate%2Ctime%2Chour%2Coffer%2Coffer_name%2Cs_affiliate%2Cevent%2Cimpressions%2Cunique_clicks%2Caffiliate_model%2Cip%2Ccurrency%2Cisp%2Ccountry%2Cconn_speed%2Clocation%2Cbrowser%2Cos%2Cos_ver%2Cdevice%2Cdevice_brand%2Cdevice_model%2Creferral_domain%2Cuseragent%2Creferral_url%2Caff_click_id%2Caff_sub1%2Caff_sub2%2Caff_sub3%2Caff_sub4%2Caff_sub5%2Cadv_sub4%2Cadv_sub5%2Cios_idfa%2Csource%2Cgoogle_aid%2Candroid_id%2Cdevice_id&sort_by=clicks&sort_type=desc&key=8a388266783df85e1ed6ed83173a0889&mid=23804&aid=671927";

  const url = baseUrl
    .replace(/date_from=[^&]*/, `date_from=${dateFrom}`)
    .replace(/date_end=[^&]*/, `date_end=${dateEnd}`);

  fetch(url, options)
    .then((res) => res.json())
    .then((res) => console.log(res))
    .catch((err) => console.error(err));
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const raw = parts.pop().split(";").shift();
    return raw ? raw.replace(/[{}]/g, "") : null; // удаляем { и }
  }
  return null;
}

export function createOffer18Affiliate({
  first_name,
  last_name,
  signup_ip,
  email,
  mid,
  api_key,
  secret_key,
}) {
  const url = new URL("https://api.offer18.com/api/m/affiliate_create/");

  // Добавляем параметры динамически
  url.searchParams.append("first_name", first_name);
  url.searchParams.append("last_name", last_name);
  url.searchParams.append("signup_ip", signup_ip);
  url.searchParams.append("email", email);
  url.searchParams.append("mid", mid);
  url.searchParams.append("api-key", api_key);
  url.searchParams.append("secret-key", secret_key);

  const options = {
    method: "POST",
    headers: {
      Accept:
        "text/html, application/xhtml+xml, application/xml;q=0.9, image/webp",
    },
  };

  fetch(url, options)
    .then((res) => res.json())
    .then((res) => console.log(res))
    .catch((err) => console.error(err));
}

export function createOffer18Offer(
  offer_name,
  advertiser_id,
  offer_url,
  mid,
  api_key,
  secret_key
) {
  const url = `https://api.offer18.com/api/m/offer_create/?type=create&mid=${mid}&api-key=${api_key}&secret-key=${secret_key}`;

  const options = {
    method: "POST",
    headers: {
      Accept:
        "text/html, application/xhtml+xml, application/xml;q=0.9, image/webp",
      "content-type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      offer_name,
      advertiser_id,
      offer_url,
    }),
  };

  fetch(url, options)
    .then((res) => res.json())
    .then((res) => console.log(res))
    .catch((err) => console.error(err));
}

export function sendImpressionFromCookies() {
  if (sessionStorage.getItem("offer18_impression_sent")) return;
  sessionStorage.setItem("offer18_impression_sent", "1");

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  const safe = (v) =>
    v && !v.startsWith("{") && v !== "replace_it" ? v : null;

  const m = safe(getCookie("m"));
  const affClickId = safe(getCookie("aff_click_id"));
  const subAffId = safe(getCookie("sub_aff_id"));
  const affSub1 = safe(getCookie("aff_sub1"));
  const affSub2 = safe(getCookie("aff_sub2"));

  if (!m || !affClickId) return;

  let url =
    `https://cryptolottery777.o18a.com/i` +
    `?m=${encodeURIComponent(m)}` +
    `&aff_click_id=${encodeURIComponent(affClickId)}`;

  if (subAffId) url += `&sub_aff_id=${encodeURIComponent(subAffId)}`;
  if (affSub1) url += `&aff_sub1=${encodeURIComponent(affSub1)}`;
  if (affSub2) url += `&aff_sub2=${encodeURIComponent(affSub2)}`;

  fetch(url, { method: "GET", mode: "no-cors" });
}

export function sendClickFromCookies() {
  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  const o = getCookie("aff_sub3");
  const m = "23804";
  const a = getCookie("sub_aff_id");
  const affClickId = getCookie("aff_click_id");
  const subAffId = getCookie("sub_aff_id");
  const affSub2 = getCookie("aff_sub2");

  const missingParams = [];
  if (!o) missingParams.push("aff_sub3");
  if (!m) missingParams.push("m");
  if (!a) missingParams.push("sub_aff_id");
  if (!affClickId) missingParams.push("aff_click_id");
  if (!subAffId) missingParams.push("sub_aff_id");
  if (!affSub2) missingParams.push("aff_sub2");

  if (missingParams.length > 0) {
    console.warn("❌ Не хватает параметров в cookies:", missingParams);
    return;
  }

  const url = `https://cryptolottery777.o18a.com/c?o=${encodeURIComponent(
    o
  )}&m=${encodeURIComponent(m)}&a=${encodeURIComponent(
    a
  )}&aff_click_id=${encodeURIComponent(
    affClickId
  )}&sub_aff_id=${encodeURIComponent(subAffId)}&aff_sub2=${encodeURIComponent(
    affSub2
  )}`;

  fetch(url, { method: "GET" })
    .then((response) => {
      if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
      return response.text();
    })
    .then((data) => console.log("✅ Click отправлен. Ответ:", data))
    .catch((error) => console.error("Ошибка при impression:", error));
}

export function saveUrlParamsToCookies() {
  const params = new URLSearchParams(window.location.search);

  const ALLOWED_KEYS = [
    "aff_click_id",
    "sub_aff_id",
    "aff_sub1",
    "aff_sub2",
    "m",
  ];

  let savedAny = false;

  ALLOWED_KEYS.forEach((key) => {
    const value = params.get(key);

    if (value && value.trim()) {
      document.cookie =
        `${key}=${encodeURIComponent(value)};` +
        `path=/;` +
        `SameSite=Lax;` +
        `max-age=${60 * 60 * 24 * 30}`;

      console.log(`🍪 COOKIE SET: ${key} = ${value}`);
      savedAny = true;
    }
  });

  if (!savedAny) {
    console.log("ℹ️ No Offer18 params found in URL");
  }
}

// export function sendOffer18Conversion(amount, txHash) {
//   const m = getCookie("m");
//   const tid = getCookie("aff_click_id");
//   const subAffId = getCookie("sub_aff_id");

//   if (!m || !tid) return;

//   const url =
//     `https://cryptolottery777.o18a.com/p` +
//     `?m=${m}` +
//     `&tid=${encodeURIComponent(tid)}` +
//     `&event=ticket_purchase` +
//     `&txid=${encodeURIComponent(txHash)}` +
//     `&amount=${amount}` +
//     (subAffId ? `&sub_aff_id=${encodeURIComponent(subAffId)}` : "");

//   fetch(url, { method: "GET", mode: "no-cors" });
// }

export function sendOffer18Conversion() {
  const m = getCookie("m");
  const tid = getCookie("aff_click_id");
  const subAffId = getCookie("sub_aff_id");

  if (!m || !tid) {
    console.warn("Missing Offer18 data");
    return;
  }

  const url =
    `https://cryptolottery777.o18a.com/p` +
    `?m=${m}` +
    `&tid=${encodeURIComponent(tid)}` +
    `&event=ticket_purchase` +
    (subAffId ? `&sub_aff_id=${encodeURIComponent(subAffId)}` : "");

  console.log("📤 Offer18 Conversion:", url);

  fetch(url, { method: "GET", mode: "no-cors" });
}
